<template>
    <div class="map">
        <div id="container"></div>
    </div>
</template>
<script>
import initMap from '@/mixins/initQQMap'
export default {
    mixins: [
        initMap
    ]
}
</script>
<style lang="scss" scoped>
.map {
    width: 80%;
    height: 100vh;
}
#container {
    width: 100%;
    height: 100%;
}
</style>
